/**
 * Copyright (c) 2020 TechDivision GmbH
 * All rights reserved
 */

/**
 * @module mobileHeaderVisibility
 */
(function () {
    /**
     * Handle mobileHeaderVisibility
     * @param header {HTMLElement}
     * @method mobileHeaderVisibility
     */
    function MobileHeaderVisibility(header) {
        /**
         * // local object availability
         * @type {mobileHeaderVisibility}
         * @private
         */
        var _this = this;

        /**
         * @type {element}
         */
        this.header = header;

        /**
         * @type {element}
         */
        this.headerMobileTop = _this.header.querySelector('[data-html-element="header__mobile-top"]');

        /**
         * @type {number}
         */
        this.previousScrollPosition = window.scrollY || document.scrollTop;

        /**
         * @type {number}
         */
        this.viewportBreakpoint = 992;

        /**
         * @type {boolean}
         */
        this.isMobile = window.innerWidth < _this.viewportBreakpoint;

        /**
         * @method init
         * @returns {undefined}
         */
        this.init = function () {
            _this.bindEvents();
        };

        /**
         * @method bindEvents
         * @return {undefined}
         */
        this.bindEvents = function () {
            window.addEventListener('scroll', function () {
                // handle Header position
                if (_this.isMobile) {
                    _this.checkScrollDirection();
                } else {
                    // reset
                    _this.header.style.top = '0px';
                }
            });

            window.addEventListener('resize', function () {
                _this.isMobile = window.innerWidth < _this.viewportBreakpoint;
            });
        };

        /**
         * Find the direction of scroll
         * @method checkScrollDirection
         * @return {undefined}
         */
        this.checkScrollDirection = function () {
            var currentScrollPosition = window.scrollY || document.scrollTop;
            var currentScrollDirection = (currentScrollPosition > _this.previousScrollPosition) ? "up" : "down";
            _this.toggleHeader(currentScrollDirection, currentScrollPosition);
            _this.previousScrollPosition = currentScrollPosition;
        };

        /**
         * toggle Header, also add extra css class in the dom as hint
         * @method toggleHeader
         * @returns {undefined}
         */
        this.toggleHeader = function (currentScrollDirection, currentScrollPosition) {
            var headerMobileTopHeight = _this.headerMobileTop.offsetHeight;
            if (currentScrollDirection === "up" && currentScrollPosition > headerMobileTopHeight) {
                _this.header.classList.add('js__hide-logo');
                _this.header.style.top = '-' + headerMobileTopHeight + 'px';
            } else if (currentScrollDirection === "down") {
                _this.header.classList.remove('js__hide-logo');
                _this.header.style.top = '0px';
            }
        };

        /**
         * initialize call mobileHeaderVisibility
         */
        _this.init();
    }

    // define the global scope
    if (!window.Jumpers) {
        window.Jumpers = {};
    }

    window.Jumpers.MobileHeaderVisibility = MobileHeaderVisibility;
})();

$(function () {
    var mobileHeader = document.querySelector('[data-html-element="header"]');
    if (mobileHeader) {
        new window.Jumpers.MobileHeaderVisibility(mobileHeader);
    }
});
